import { FindNativeFeature } from '../Feature/Features';
export var NoteType;
(function (NoteType) {
    NoteType["Authentication"] = "authentication";
    NoteType["Code"] = "code";
    NoteType["Markdown"] = "markdown";
    NoteType["RichText"] = "rich-text";
    NoteType["Spreadsheet"] = "spreadsheet";
    NoteType["Task"] = "task";
    NoteType["Plain"] = "plain-text";
    NoteType["Super"] = "super";
    NoteType["Unknown"] = "unknown";
})(NoteType || (NoteType = {}));
export function noteTypeForEditorIdentifier(identifier) {
    const feature = FindNativeFeature(identifier);
    if (feature && feature.note_type) {
        return feature.note_type;
    }
    return NoteType.Unknown;
}
